import React from 'react';
import {RouteType} from '../../global/types/route.type';
import {appRoutes} from './appRoutes';

export const authRoute: RouteType[] = [
    {
        key: 'Login',
        path: appRoutes.auth.loginIn(),
        component: React.lazy(() => import('views/auth/Login')),
        authorities: [],
    },
    // {
    //     key: 'register',
    //     path: appRoutes.auth.register(),
    //     component: React.lazy(() => import('views/auth/Register')),
    //     authorities: [],
    // },
    // {
    //     key: 'forgotPassword',
    //     path: appRoutes.auth.forgotPassword(),
    //     component: React.lazy(() => import('views/auth/ForgotPassword')),
    //     authorities: [],
    // },
    // {
    //     key: 'resetPassword',
    //     path: appRoutes.auth.resetPassword(),
    //     component: React.lazy(() => import('views/auth/ResetPassword')),
    //     authorities: [],
    // },
    {
        key: 'setPassword',
        path: appRoutes.auth.setPassword(),
        component: React.lazy(() => import('views/auth/SetPassword')),
        authorities: [],
    },
    // {
    //     key: 'userInvitation',
    //     path: appRoutes.auth.userInvitation(),
    //     component: React.lazy(() => import('views/auth/UserInvitation')),
    //     authorities: [],
    // },
    // {
    //     key: 'logout',
    //     path: appRoutes.auth.logout(),
    //     component: React.lazy(() => import('views/auth/Login')),
    //     authorities: [],
    // },
    // {
    //     key: 'checkMail',
    //     path: appRoutes.auth.checkMail(),
    //     component: React.lazy(() => import('views/auth/CheckMail')),
    //     authorities: [],
    // },
    // {
    //     key: 'codeVerification',
    //     path: appRoutes.auth.codeVerification(),
    //     component: React.lazy(() => import('views/auth/CodeVerification')),
    //     authorities: [],
    // },
    // {
    //     key: 'google-login',
    //     path: '/google-login',
    //     component: React.lazy(() => import('views/auth/GoogleLogin')),
    //     authorities: [],
    // },
    // {
    //     key: 'microsoft-login',
    //     path: '/microsoft-login',
    //     component: React.lazy(() => import('views/auth/MicrosoftLogin')),
    //     authorities: [],
    // },
];

export default authRoute;
